// extracted by mini-css-extract-plugin
export default {"products-container":"products-list_products-container__QOKFI","title-container":"products-list_title-container__LPXPt","products-title":"products-list_products-title__9KC-E"};